//copied (and enhanced) from carbon-enterprise
const searchCalculatorParamsToArray = (urlParams) => {
    let currency = urlParams.get("currency") || urlParams.get("CURRENCY");
    let flightParams = urlParams.getAll("flight").map(p => p.toUpperCase());
    let country = urlParams.get("country");
    let pax = urlParams.get("pax") || urlParams.get("PAX");
    const merchantCode = urlParams.get("merchantCode");
    const programmeCode = urlParams.get("programmeCode");
    const destination = urlParams.get("destination");
    const analyticsMode = urlParams.get("analyticsMode");

    if (!pax || flightParams.length < 1
        || flightParams.some(p => !/^[A-Z]{3}-[A-Z]{3}-(Economy|Premium_Economy|Business|First)$/i.test(p)))
        flightParams = null;

    if (currency && currency.length !== 3){
        currency = null;
    }

    return { pax, flightParams, currency, country, merchantCode, programmeCode, destination, analyticsMode };
};

export { searchCalculatorParamsToArray }